import(/* webpackMode: "eager" */ "/app/src/app/[domain]/[lang]/error.tsx");
